import { render, staticRenderFns } from "./studioResult.vue?vue&type=template&id=9dbac826&"
import script from "./studioResult.vue?vue&type=script&lang=js&"
export * from "./studioResult.vue?vue&type=script&lang=js&"
import style0 from "./studioResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports